import { defineComponent as S, ref as h, computed as B, watch as E, createElementBlock as s, openBlock as d, normalizeStyle as y, normalizeClass as n, unref as t, createCommentVNode as o, createElementVNode as r, withDirectives as C, renderSlot as i, createStaticVNode as I, createVNode as P, vShow as N } from "vue";
import { EDITOR_ID as w, DocumentClasses as c, EditorClasses as V } from "@scalar-org/css";
import { useResizeObserver as D, useMediaQuery as $ } from "@vueuse/core";
import G from "./components/PageNav.vue.js";
import "./components/PageNav.vue2.js";
import z from "./components/TableOfContents.vue.js";
const O = ["id"], R = {
  key: 0,
  class: "layout-header"
}, L = {
  key: 1,
  class: "layout-aside-content"
}, M = ["id"], A = { class: "layout-aside-right" }, H = { class: "layout-footer" }, U = /* @__PURE__ */ S({
  __name: "ApiGuide",
  props: {
    activePage: {},
    editorViewportId: {},
    showSidebar: { type: Boolean },
    footerBelowSidebar: { type: Boolean },
    sidebar: {},
    headings: {},
    isLoaded: { type: Boolean }
  },
  emits: ["goToNextPage", "goToPrevPage"],
  setup(k) {
    const u = k, m = h(0), b = h(null);
    D(b, (e) => {
      m.value = e[0].contentRect.height;
    });
    const g = $("(max-width: 1120px)"), l = $("(max-width: 1000px)"), T = B(() => {
      var e;
      return `Guide / ${(e = u.activePage) == null ? void 0 : e.title}`;
    });
    return E(
      () => {
        var e;
        return (e = u.activePage) == null ? void 0 : e.uid;
      },
      () => {
        const e = document.getElementById(w);
        e && (e.scrollTop = 0);
      }
    ), (e, a) => {
      var f, p;
      return d(), s("main", {
        id: t(w),
        ref_key: "documentEl",
        ref: b,
        class: n({
          [t(c).Document]: !0,
          "footer-below-sidebar": e.footerBelowSidebar,
          "hide-aside-right": t(g)
        }),
        style: y({ "--full-height": `${m.value}px` })
      }, [
        t(l) ? o("", !0) : (d(), s("div", R, [
          i(e.$slots, "header", {}, void 0, !0)
        ])),
        r("aside", {
          class: n(["layout-aside-left", t(c).Sidebar])
        }, [
          t(l) ? i(e.$slots, "mobile-header", {
            key: 0,
            label: T.value
          }, void 0, !0) : o("", !0),
          e.showSidebar || !t(l) ? (d(), s("div", L, [
            t(l) ? i(e.$slots, "header", { key: 0 }, void 0, !0) : o("", !0),
            i(e.$slots, "guide-sidebar", {}, void 0, !0)
          ])) : o("", !0)
        ], 2),
        (f = e.activePage) != null && f.backgroundImage ? (d(), s("div", {
          key: 1,
          class: "layout-image",
          style: y(`background-image: url(${e.activePage.backgroundImage})`)
        }, null, 4)) : o("", !0),
        C(r("div", {
          class: n(["editor layout-content", t(V).Editor])
        }, [
          a[2] || (a[2] = I('<div class="section-flare-guide" data-v-99adb4b5><div class="section-flare" data-v-99adb4b5><div class="section-flare-item" data-v-99adb4b5></div><div class="section-flare-item" data-v-99adb4b5></div><div class="section-flare-item" data-v-99adb4b5></div><div class="section-flare-item" data-v-99adb4b5></div><div class="section-flare-item" data-v-99adb4b5></div><div class="section-flare-item" data-v-99adb4b5></div><div class="section-flare-item" data-v-99adb4b5></div><div class="section-flare-item" data-v-99adb4b5></div></div></div>', 1)),
          i(e.$slots, "editor-content", {}, void 0, !0),
          P(G, {
            activePage: e.activePage,
            sidebar: e.sidebar,
            onGoToNextPage: a[0] || (a[0] = (v) => e.$emit("goToNextPage", v)),
            onGoToPrevPage: a[1] || (a[1] = (v) => e.$emit("goToPrevPage", v))
          }, null, 8, ["activePage", "sidebar"]),
          r("div", {
            id: e.editorViewportId,
            class: "layout-content-viewport"
          }, null, 8, M)
        ], 2), [
          [N, e.isLoaded]
        ]),
        r("aside", A, [
          t(g) ? o("", !0) : (d(), s("div", {
            key: 0,
            class: n(["custom-scroll custom-scroll-self-contain-overflow", [t(c).TableOfContents]])
          }, [
            P(z, {
              headings: e.headings,
              pageTitle: ((p = e.activePage) == null ? void 0 : p.title) || ""
            }, null, 8, ["headings", "pageTitle"])
          ], 2))
        ]),
        r("div", H, [
          i(e.$slots, "footer", {}, void 0, !0)
        ])
      ], 14, O);
    };
  }
});
export {
  U as default
};
